import { Logger, LOG_LEVEL } from 'beaver-logger'
import {
  CONTENT_SERVER_ROOT_URL,
  CONTENT_SERVER_ENDPOINTS,
} from '../appConstants'

const LOG_PREFIX = 'CONTENT_CLIENT'

// https://github.com/krakenjs/beaver-logger#configuration
const beaverLogger = new Logger({
  // URL to post logs to
  url: `${CONTENT_SERVER_ROOT_URL}${CONTENT_SERVER_ENDPOINTS.LOG}`,

  // Prefix for each log
  prefix: LOG_PREFIX,

  // Interval at which to automatically flush logs to the server
  flushInterval: 60 * 100,

  // Log level to display in the browser console
  logLevel: LOG_LEVEL.INFO,
})

// Convert message to an object if not already
const normalizeMessage = message => {
  let payload = message

  if (typeof message !== 'object') {
    payload = {
      message,
    }
  } else if (message instanceof Error) {
    payload = {
      message: String(message),
    }
  }

  return payload
}

// Normalize message
const normalizeLog = logFn => (...args) => {
  if (!args.length) {
    return console.warn('No arguments were passed into logger')
  } else if (args.length === 1) {
    return logFn(args[0])
  }

  return logFn(args[0], normalizeMessage(args[1]))
}

// Attach beaver-logger functions to the logger
export function applyBeaverLogger(logger) {
  const contentLogger = {}

  // Log to CAL
  // ie. contentLogger.cal.error('SERVICE_ERROR', { message: 'My error' }))
  // https://github.com/krakenjs/beaver-logger#basic-logging
  contentLogger.cal = {}
  ;['info', 'debug', 'warn', 'error'].forEach(call => {
    contentLogger.cal[call] = normalizeLog(logger[call])
  })

  // Flush logs manually (beaver-logger flushes automatically in intervals)
  contentLogger.flush = logger.flush

  // Flush logs immediately without debouncing
  contentLogger.immediateFlush = logger.immediateFlush

  return contentLogger
}

export function attachUnloadListeners(contentLogger) {
  // Flush logs before unload
  window.addEventListener('beforeunload', () => {
    contentLogger.cal.info('window_beforeunload')
    contentLogger.immediateFlush()
  })

  // Flush logs before unload
  window.addEventListener('unload', () => {
    contentLogger.cal.info('window_unload')
    contentLogger.immediateFlush()
  })
}

const contentLogger = applyBeaverLogger(beaverLogger)
attachUnloadListeners(contentLogger)

export default contentLogger
